export const isWorkflowsEnabled =
  import.meta.env.VITE_WORKFLOWS_ENABLED === 'true';

export const isTiaV2Enabled = import.meta.env.VITE_TIA_V2_ENABLED === 'true';

/** Passkeys need both the flag and the vh3-auth Worker URL. Off on PR previews (their hostnames change). */
export const AUTH_BROKER_URL = (
  import.meta.env.VITE_AUTH_BROKER_URL ?? ''
).replace(/\/+$/, '');

export const isPasskeysEnabled =
  import.meta.env.VITE_PASSKEYS_ENABLED === 'true' && AUTH_BROKER_URL !== '';

/**
 * Knowledge Base file pickers (vH3-Digital/paragon#54). Google Drive needs the
 * flag and both Google Picker values; without them the option is hidden.
 */
export const GOOGLE_PICKER_CONFIG = {
  developerKey: import.meta.env.VITE_GOOGLE_PICKER_API_KEY ?? '',
  appId: import.meta.env.VITE_GOOGLE_PICKER_APP_ID ?? '',
};

export const isKbGoogleDrivePickerEnabled =
  import.meta.env.VITE_KB_FILE_PICKERS_ENABLED === 'true' &&
  GOOGLE_PICKER_CONFIG.developerKey !== '' &&
  GOOGLE_PICKER_CONFIG.appId !== '';
